import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SubmissionConstants {
  //used in custom-forms-rules.service.ts
  soldDateWarning: string =
    'Sold date must be greater than the manufacture date.';
  completionDateWarning: string =
    'Completion date cannot be older than the manufacture date.';
  streetAddressWarning: string = "Street address cannot be 'TBD'.";
  heatPumpDocWarning: string =
    'Heat Pump Document on File is required to be "Yes" in order to set status to "Ready To Submit".';
  pointsWarning: string =
    'Not enough points have been claimed to submit this home.';
  zerhPlantWarning: string =
    'This home has a manufacture date prior to the ZERH plant certification and therefore does not qualify for Energy Star Version 3 or ZERH. Please submit this home as Energy Star Version 2 if it meets the minimum requirements.';
  zerhGoLiveWarning: string =
    'Note, this home was manufactured prior to the ZERH go live date. Please confirm that this home was built with all the required additional requirements for EStar Version 3 and ZERH. Additional requirements include but are not limited to, insulation baffles, energy star whole house fan, energy star bath fans, manual S calculations, etc.';
  waterHeatingEBuiltWarning: string =
    'An eBuilt option code is present, but the home does not have the required "AC" at the end of the serial number. Please reach out to home office for assistance.';
  manufactureDateError: string =
    'This home has a manufacture date prior to the ZERH plant certification and therefore does not qualify for Energy Star Version 3 or ZERH. Please contact the admin or support so this home can be submitted as Energy Star Version 2 if it meets the minimum requirements.';
  zipCodeError: string = 'Zip code must be a 5-digit numerical value.';

  //localStorage Variables
  formStructureIdKey: string = 'formStructureId';
  climateZoneKey: string = 'climateZone';
  usStates: string = 'usStates';

  //property bindings
  homeSerialNumber: string = 'homeSerialNumber';
  homeManufacturedDate: string = 'homeManufacturedDate';
  homeSoldDate: string = 'homeSoldDate';
  facilityName: string = 'facilityName';
  homeCenterNumber: string = 'homeCenterNumber';
  ownerFullName: string = 'ownerFullName';
  isCertificateMailed: string = 'isCertificateMailed';
  completionDate: string = 'completionDate';

  //submission table columns + labels used in submission-list-view.component
  tableColumns = {
    FACILITY_NUMBER: 'FacilityNumber',
    SERIAL_NUMBER: 'SerialNumber',
    VERSION: 'Version',
    STATUS: 'Status',
    FURNACE_TYPE: 'FurnaceType',
    HEAT_PUMP_INVOICE_AVAILABLE: 'HeatPumpInvoiceAvailable',
    ORDER_NUMBER: 'OrderNumber',
    HOME_CENTER_NAME: 'RetailerName',
    CUSTOMER_NAME: 'CustomerName',
    SOLD_DATE: 'SoldDate',
    CERTIFICATE_MAILED: 'CertificateMailed',
    SUBMISSION_CREATE_DATE: 'SubmissionCreateDate',
  };

  tableColumnLabels = {
    [this.tableColumns.FACILITY_NUMBER]: 'Facility #',
    [this.tableColumns.SERIAL_NUMBER]: 'Serial #',
    [this.tableColumns.VERSION]: 'Version',
    [this.tableColumns.STATUS]: 'Status',
    [this.tableColumns.FURNACE_TYPE]: 'Furnace Type',
    [this.tableColumns.HEAT_PUMP_INVOICE_AVAILABLE]:
      'Heat Pump Invoice Available',
    [this.tableColumns.ORDER_NUMBER]: 'Order #',
    [this.tableColumns.HOME_CENTER_NAME]: 'Retailer',
    [this.tableColumns.CUSTOMER_NAME]: 'Customer',
    [this.tableColumns.SOLD_DATE]: 'Sold Date',
    [this.tableColumns.CERTIFICATE_MAILED]: 'Certificate Mailed',
    [this.tableColumns.SUBMISSION_CREATE_DATE]: 'Submission Create Date',
  };

  NEEMFacilities = ['955', '972'];

  //submission statuses
  statusReadyToSubmit: string = 'Ready To Submit';
  statusInProgress: string = 'In Progress';
  statusNeedsAttention: string = 'Needs Attention';
  statusNotEligible: string = 'Not Eligible';
  statusOnHold: string = 'On Hold';
  statusSubmitted: string = 'Submitted';
  statusSubmittedManually: string = 'Submitted Manually';
  statusError: string = 'Error';

  submittedStatuses: string[] = [
    this.statusSubmitted,
    this.statusSubmittedManually,
  ];

  //submissions unsaved ChangesDialog
  subDtlDialogTitle: string = 'Unsaved Changes';
  subDtlDialogMessage: string =
    'You are about to close your submission with unsaved changes. All changes made will be lost. Do you wish to proceed?';
  buttonTxtCancel: string = 'Cancel';
  buttonTxtConfirm: string = 'Confirm';

  //submissions SBRA submit failed ChangesDialog
  subSbraFailGeneralDialogTitle: string =
    'There was a problem with your SBRA submission. Check all your information, and resubmit';

  subSbraFailDuplicateTitle: string =
    'There was a problem with your SBRA submission. Check all your information.';

  subSbraFailDuplicateMessage: string =
    'This home already has a submission recorded in the SBRA Info Manager. Change status to Submitted Manually and save.'

  subSbraGenericFailMessage: string =
    'An error occurred when saving your submission. Try to resubmit or reach out to the home office at hbgestar-45l@claytonhomes.com .'

  //submissions SBRA submit success ChangesDialog
  subSbraSuccessDialogTitle: string = 'Success!';
  subSbraSuccessDialogMessage: string = 'Your SBRA submission was successful';

  //Submission form submit banners
  bannerSbraV2Success: string = 'Submission to SBRA was successful.';
  bannerSbraV3Success: string = 'Submission details have been saved and will be delivered to SBRA in the next batch, Tuesday at 2AM.';
  bannerIsNeemSuccess: string = 'Submission details have been saved to ClaytonNEXT.';
  bannerGeneralStatusSuccess: string = 'Submission details have been saved.';

  //submission SBRA submit ChangesDialog button constants
  subSbraButtonTxtCancel: string = '';
  subSbraButtonTxtConfirm: string = 'Ok';
  subSbraShowCancelButton: boolean = false;
  // button constants
  defaultButtonTxtCancel: string = '';
  defaultButtonTxtConfirm: string = 'Ok';
  defaultShowCancelButton: boolean = false;

  //SBRA design package options (V2)
  designPackageEhpOptions = ['1-EHP', '2-EHP', '3-EHP'];
  designPackageGasOptions = ['1-GAS', '2-GAS', '3-GAS'];
  designPackageEnvOptions = ['1-ENV', '2-ENV', '3-ENV'];

  // Version Conversion Constants
  convertV3ToV2ConfirmationDialogTitle: string = 'Convert Submission to V2';
  convertV3ToV2ConfirmationDialogMessage: string =
    'Are you sure you want to convert this submission from Version 3 to Version 2? This action cannot be undone.';

  convertV3ToV2FailedDialogTitle: string = 'Conversion Failed';
  convertV3ToV2FailedDialogMessage: string =
    'There was a problem converting this submission to Version 2. Please contact support.';

  convertV2ToV3ConfirmationDialogTitle: string = 'Convert Submission to V3';
  convertV2ToV3ConfirmationDialogMessage: string =
    'Are you sure you want to convert this submission from Version 2 to Version 3? This action cannot be undone.';

  convertV2ToV3FailedDialogTitle: string = 'Conversion Failed';
  convertV2ToV3FailedDialogMessage: string =
    'There was a problem converting this submission to Version 3. Please contact support.';

  // Manual Submissions Dialog
  manualSubmissionTitle: string = 'Create Manual Submission';
  createButtonText: string = 'Create';
  cancelButtonText: string = 'Cancel';
  manualSubmissionLabel: string = 'Search by Serial #';
  manualSubmissionPlaceholder: string = 'Long Serial #'; // Manual Submissions Error Messages
  requiredErrMsg: string = 'This field is required.';
  specialCharErrMsg: string = 'No special characters allowed.';
  maxLengthErrMsg: string = 'Serial Number cannot exceed 20 characters.';

  // Manual Submissions Status
  manualSubNotFound: string = 'NotFound';
  manualSubExists: string = 'Exists';
  manualSubCreated: string = 'Created';
  manualSubNotAllowed: string = 'NotAllowed';
  manualSubFailed: string = 'Failed';

  // Tooltips
  heatPumpInvoiceAvailableToolTip: string = 'Invoice Available';
}
